interface Action {
    payload: any,
    type: string,
    field: string,
    subfield?: string
    value?: { length?: number },
    base?: any,
    coefficient?: number | null,
    validate: boolean,
}

const errors: {
    [key: string]: string
} = {
    price: "Minimum price is $!price!.",
    payment_type: "Please select a payment type."
};

export default (data: any, action: Action) => {

    const newForm = {...data};
    const prop = newForm[action.field];

    if (prop) {
            if (!prop.added && (action.value || (!action.value && action.validate))) {
                prop.added = true
            }

            if (action.field === 'price' && (action.subfield !== 'contingency' && action.subfield !== 'pro_bono')) {
                const val = action.value || 0;
                prop.error = val < action.base ? errors[action.field].replace('!price!', action.base) : null;
                prop.coefficient = action.coefficient;
            } else {
                prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
            }
            prop.value = action.value;

        }
        // const paymentMethodField = action.field === "paymentMethod";
        const isContingency = newForm.payment_type.value === 'contingency' || newForm.payment_type.value === 'pro_bono';
        const vals = Object.values(newForm).filter((f: any) => f.required);

        const valid = vals.filter((f: any) => {
            const value = isContingency ? true : f.value;
            return f.added && value && !f.error
        });


        return {
            changed: true,
            valid: isContingency ? true : (vals.length === valid.length),
            data: newForm,
        };
};
